import moment from 'moment'

import { useAppSelector } from '~/store/hooks'

import { ROAS_CUTOFF_DATE } from '../constants'

export function useClickMetricsCutoffAlert(
  options: { checkCompare?: boolean } = {}
): boolean {
  const { startDate, compareStartDate } = useAppSelector(
    state => state.datepickerHeader
  )
  const cutoff = moment(ROAS_CUTOFF_DATE, 'DD/MM/YYYY')
  if (!startDate) return false
  if (moment(startDate).isBefore(cutoff, 'day')) return true
  if (
    options.checkCompare &&
    compareStartDate &&
    moment(compareStartDate).isBefore(cutoff, 'day')
  )
    return true
  return false
}
